import { Component } from '@angular/core';

/**
 * @description Component
 * @class SpinnerComponent
 */
@Component({
  standalone: false,
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})

export class SpinnerComponent {

  /**
   * @description Creates an instance of SpinnerComponent.
   */
  constructor() { }
}
